export default getText => key =>
  ({
    text1: getText('Password needs to be at least', 'Auth_Reset_Password_Popup'),
    text2: getText('8 characters', 'Auth_Reset_Password_Popup'),
    text3: getText('long and contain', 'Auth_Reset_Password_Popup'),
    text4: getText('uppercase letters, lowercase letters', 'Auth_Reset_Password_Popup'),
    text5: getText('and', 'Auth_Reset_Password_Popup'),
    text6: getText('numbers.', 'Auth_Reset_Password_Popup'),
  }[key])
